import { type ReactNode } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/**
 * Markdown renderer backed by react-markdown + remark-gfm (tables, task lists,
 * strikethrough, autolinks). Renders straight to React nodes (no
 * dangerouslySetInnerHTML), so escaping is handled by React itself.
 */
export function renderMarkdown(md: string): ReactNode {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        a: ({ node: _node, ...props }) => (
          <a {...props} target="_blank" rel="noopener" />
        ),
      }}
    >
      {md}
    </ReactMarkdown>
  );
}
